(() => {
  const __shopifySectionId = document.currentScript?.dataset.sectionId || '';

  const modal = document.getElementById(("YurchakCollectionSizeGate-" + __shopifySectionId + ""));
  if (!modal || modal.dataset.ready === 'true') return;
  modal.dataset.ready = 'true';

  const titleNode = modal.querySelector('[data-ycsg-title]');
  const colorNode = modal.querySelector('[data-ycsg-color]');
  const sizesNode = modal.querySelector('[data-ycsg-sizes]');
  const statusNode = modal.querySelector('[data-ycsg-status]');
  const actionButton = modal.querySelector('[data-ycsg-action]');
  let state = null;
  let previousOverflow = '';
  let returnFocus = null;

  const parse = (node, fallback = []) => {
    try { return JSON.parse(node?.textContent || JSON.stringify(fallback)); }
    catch (_) { return fallback; }
  };
  const optionNames = card => {
    try { return JSON.parse(card.dataset.optionNames || '[]'); }
    catch (_) { return []; }
  };
  const optionIndex = (names, pattern) => names.findIndex(name => pattern.test(String(name || '').toLowerCase()));
  const routeRoot = () => window.Shopify?.routes?.root || '/';

  const close = () => {
    if (modal.hidden) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden','true');
    document.documentElement.style.overflow = previousOverflow;
    state = null;
    returnFocus?.focus?.();
    returnFocus = null;
  };

  const findVariant = (entry, size) => entry.variants.find(variant => {
    if (!variant.available || variant.options?.[entry.sizeIndex] !== size) return false;
    if (entry.colorIndex >= 0 && entry.colorValue && variant.options?.[entry.colorIndex] !== entry.colorValue) return false;
    return true;
  }) || null;

  const selectSize = (button, size) => {
    if (!state || button.disabled) return;
    state.selected = findVariant(state, size);
    sizesNode.querySelectorAll('[data-ycsg-size]').forEach(node => node.classList.toggle('is-active', node === button));
    actionButton.disabled = !state.selected;
    statusNode.textContent = state.selected ? '' : 'This size is unavailable in the selected color.';
  };

  const open = (card, mode, trigger) => {
    const variants = parse(card.querySelector('[data-ysc-variants]'));
    const names = optionNames(card);
    const sizeIndex = optionIndex(names, /size|розмір|размер/);
    if (sizeIndex < 0 || !variants.length) return false;

    const colorIndex = optionIndex(names, /color|colour|колір|цвет/);
    const current = variants.find(variant => String(variant.id) === String(card.dataset.variantId)) || variants.find(variant => variant.available) || variants[0];
    const colorValue = colorIndex >= 0 ? current?.options?.[colorIndex] || '' : '';
    const sizes = [...new Set(variants.map(variant => variant.options?.[sizeIndex]).filter(Boolean))];

    state = {card, mode, variants, sizeIndex, colorIndex, colorValue, selected:null};
    titleNode.textContent = card.querySelector('.ysc__title')?.textContent?.trim() || 'Choose your size';
    colorNode.textContent = colorValue ? `Color: ${colorValue}` : 'Choose an available size';
    statusNode.textContent = '';
    actionButton.textContent = mode === 'buy' ? 'BUY NOW' : 'ADD TO BAG';
    actionButton.disabled = true;
    sizesNode.innerHTML = '';

    sizes.forEach(size => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'ycsg__size';
      button.dataset.ycsgSize = '';
      button.textContent = size;
      const variant = findVariant(state, size);
      button.disabled = !variant;
      button.setAttribute('aria-label', variant ? `Select size ${size}` : `Size ${size} unavailable`);
      button.addEventListener('click', () => selectSize(button, size));
      sizesNode.appendChild(button);
    });

    if (![...sizesNode.children].some(button => !button.disabled)) statusNode.textContent = 'This color is currently sold out.';
    returnFocus = trigger || document.activeElement;
    previousOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    modal.hidden = false;
    modal.setAttribute('aria-hidden','false');
    modal.querySelector('[data-ycsg-close]')?.focus();
    return true;
  };

  const showSuccess = () => {
    let toast = document.getElementById('ycsg-added-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'ycsg-added-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      Object.assign(toast.style, {position:'fixed',bottom:'24px',left:'50%',transform:'translateX(-50%)',zIndex:'2147483647',background:'#111',color:'#fff',padding:'13px 20px',borderRadius:'999px',fontSize:'14px',boxShadow:'0 5px 20px #0003',maxWidth:'90vw',textAlign:'center'});
      document.body.appendChild(toast);
    }
    toast.textContent = 'Added to bag ✓';
    toast.hidden = false;
    clearTimeout(toast._hideTimer);
    toast._hideTimer = setTimeout(() => { toast.hidden = true; }, 3200);
  };

  const addToBag = async variantId => {
    const core = window.YurchakCartCore;
    const cartUi = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const payload = {items:[{id:Number(variantId),quantity:1}]};
    if (cartUi?.getSectionsToRender) {
      payload.sections = cartUi.getSectionsToRender().map(section => section.id);
      payload.sections_url = location.pathname;
      cartUi.setActiveElement?.(document.activeElement);
    }
    const response = await fetch(window.routes?.cart_add_url || ((window.Shopify?.routes?.root || '/') + 'cart/add.js'), {
      method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json',Accept:'application/json','X-Requested-With':'XMLHttpRequest'},
      body:JSON.stringify(payload)
    });
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || result.message || 'Could not add product.');
    showSuccess();
    try { if (cartUi?.renderContents && result.sections) cartUi.renderContents(result); } catch (error) { console.warn('Cart UI refresh failed',error); }
    try {
      const cart = core?.fetchCart
        ? await core.fetchCart()
        : await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}}).then(r => r.json());
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate,{source:'yurchak-shop-card-size',productVariantId:variantId,cartData:cart});
      }
      if (core?.emit) core.emit(cart,'yurchak-shop-card-size','item-added',{productVariantId:variantId});
      else document.dispatchEvent(new CustomEvent('yurchak:cart-updated',{detail:{cart,source:'yurchak-shop-card-size',action:'item-added',productVariantId:variantId}}));
    } catch (error) { console.warn('Cart synchronization failed after successful add',error); }
    return result;
  };

  document.addEventListener('click', event => {
    const target = event.target.closest?.('[data-ysc-cart],[data-ysc-buy]');
    const card = target?.closest?.('[data-ysc-card]');
    if (!target || !card) return;
    const names = optionNames(card);
    if (optionIndex(names, /size|розмір|размер/) < 0) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    open(card, target.matches('[data-ysc-buy]') ? 'buy' : 'cart', target);
  }, true);

  modal.querySelectorAll('[data-ycsg-close]').forEach(node => node.addEventListener('click', close));
  document.addEventListener('keydown', event => {
    if (modal.hidden) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = [...modal.querySelectorAll('button:not(:disabled),a[href],input:not(:disabled),select:not(:disabled),textarea:not(:disabled),[tabindex]:not([tabindex="-1"])')]
      .filter(node => !node.hidden && node.getClientRects().length);
    if (!focusable.length) {
      event.preventDefault();
      return;
    }
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  actionButton.addEventListener('click', async () => {
    if (!state?.selected || actionButton.disabled) return;
    const variantId = state.selected.id;
    if (state.mode === 'buy') {
      location.assign(`${routeRoot()}cart/${variantId}:1?checkout`);
      return;
    }
    actionButton.classList.add('is-loading');
    actionButton.disabled = true;
    statusNode.textContent = '';
    try {
      await addToBag(variantId);
      state.card.dataset.variantId = variantId;
      statusNode.textContent = 'Added to bag.';
      window.setTimeout(close, 320);
    } catch (error) {
      statusNode.textContent = error?.message || 'Something went wrong.';
      actionButton.disabled = false;
    } finally {
      actionButton.classList.remove('is-loading');
    }
  });
})();
